import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {tap, catchError} from 'rxjs/operators';
import {Company} from '../models/database_models/company';
import {CompanyAdmin} from '../models/database_models/company_admin';
import {User} from '../models/database_models/user';
import {environment} from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class CompanyService {
	API_ENDPOINT: string = 'api/Company/';
	API_URL: string = environment.API_URL + this.API_ENDPOINT;
	ADD_COMPANY: string = 'AddCompany';
	GET_ALL_COMPANIES: string = 'GetAllCompanies';
	GET_USER_COMPANIES: string = 'GetUserCompanies';
	GET_COMPANY_ADMINS: string = 'GetCompanyAdminUsers';
	GET_COMPANY_BY_ID: string = 'getCompanyByid';
	GET_COMPANY_ADMIN: string = 'GetCompanyAdmin';
	DELETE_COMPANY: string = 'DeleteCompany';
	ACTIVE_COMPANY: string = 'activateCompany';
	UPDATE_COMPANY: string = 'UpdateCompany';
	LIQUIDATE_COMPANY: string = 'LiquidateCompany';
	LIQUIDATE_COMPLETE_COMPANY: string = 'CompleteLiquidateCompany';

	constructor(private http: HttpClient) {
	}

	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
			'Authorization': 'Bearer ' + localStorage.getItem('token')
		})
	};

	addNewCompany(company: Company): Observable<Company> {
		return this.http.post<Company>(this.API_URL + this.ADD_COMPANY, company, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	updateCompany(company: Company): Observable<Company> {
		return this.http.post<Company>(this.API_URL + this.UPDATE_COMPANY, company, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	getCompanies(): Observable<Company[]> {
		// alert(1);
		// if method is not called by a Sysem Admin, filter query by company id of the current company user
		if (localStorage.getItem('userRole') == '2' && localStorage.getItem('COMPANYID') != null) {
			return this.getUserCompanies(localStorage.getItem('COMPANYID'));
		}

		return this.http.get<Company[]>(this.API_URL + this.GET_ALL_COMPANIES, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}


	getUserCompanies(companyId: string): Observable<Company[]> {
		return this.http.get<Company[]>(this.API_URL + this.GET_USER_COMPANIES + '?companyId=' + companyId, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}


	getCompanyAdmins(): Observable<CompanyAdmin[]> {
		return this.http.get<CompanyAdmin[]>(this.API_URL + this.GET_COMPANY_ADMINS, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	getCompany(companyid): Observable<Company> {
		return this.http.get<Company>(this.API_URL + this.GET_COMPANY_BY_ID + '?companyid=' + companyid, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	CompanyAdmin(companyid): Observable<User> {
		return this.http.get<User>(this.API_URL + this.GET_COMPANY_ADMIN + '?companyid=' + companyid, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	handleError(err: HttpErrorResponse) {
		let errorMessage = '';
		if (err.error instanceof ErrorEvent) {
			errorMessage = err.error.message;
		} else {
			errorMessage = (err.error != null) ? err.error : 'Sistemsel Bir Hata!';
		}
		return throwError(errorMessage);
	}

	liquidateCompany(companyId: string, fromDate: Date): Observable<Company> {
		const requestData = {
			ID: companyId,
			FromDate: fromDate
		};
		return this.http.post<Company>(this.API_URL + this.LIQUIDATE_COMPANY, requestData, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	deleteCompany(companyId: string): Observable<Company> {
		const requestData = {
			ID: companyId
		};
		return this.http.post<Company>(this.API_URL + this.DELETE_COMPANY, requestData, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	activateCompany(companyId: string): Observable<Company> {
		const requestData = {
			ID: companyId
		};
		return this.http.post<Company>(this.API_URL + this.ACTIVE_COMPANY, requestData, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}

	tasfiyeEtCompany(companyId: string): Observable<Company> {
		const requestData = {
			ID: companyId
		};
		return this.http.post<Company>(this.API_URL + this.LIQUIDATE_COMPLETE_COMPANY, requestData, this.httpOptions).pipe(
			tap(data => data),
			catchError(this.handleError)
		);
	}
}


